<template>
  <router-link :to="to">
    <div class="flex items-center p-2 rounded-lg mt-4"
         @touchstart="toggleAnimation" @touchend="toggleAnimation">
      <div class="bg-brand/20 rounded-lg p-1 shadow">
        <slot></slot>
      </div>
      <span class="mr-4">{{ title }}</span>
      <ChevronLeftIcon class="w-5 h-5 mr-auto"/>
    </div>
  </router-link>
</template>

<script>


export default {
  name: "ProfileCard",
  props: ['title', 'to'],
  components: {},
  methods: {
    toggleAnimation(event) {
      event.currentTarget.classList.toggle('bg-brand/20')
    }
  }
}
</script>

<style scoped>

</style>